<template>
  <div class="row g-3 mb-4">
    <div v-for="card in cards" :key="card.label" class="col-12 col-sm-6 col-xl-3">
      <div class="card shadow-sm border-0 rounded-custom h-100">
        <div class="card-body p-4">
          <p class="text-muted text-uppercase small mb-2">{{ card.label }}</p>
          <h3 class="text-violet mb-1">{{ card.value }}</h3>
          <p class="text-muted small mb-0">{{ card.caption }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CamProductionIndexSummaryCards",
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
